import React from 'react'
import './styles.scss'

const CTA = () => {
  return (
    <button className="cta">Request Invite</button>
  )
}

export default CTA